import React, { useState, useLayoutEffect, useEffect, useContext } from 'react';
import styled, { css } from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import MenuPlayIcon from '../../../Icons/Menu';
import SearchStarIcon from '../../../Icons/Search';
import ClaudeIcon from '../../../Icons/Casino';
import GameIcon from '../../../Icons/Game';
import MessageIcon from '../../../Icons/Chat';
import { addNewStyle, CRISTP_ID, getUID, wait, API, sendNotfication } from '../../../Helper';
import LotteryIcon from '../../../Icons/Lottery';
import storage from '../../../Storage';
import { useGameLaunch } from '../../../Context/GameLaunchContext';
import { launchGame } from '../../../services/gameLaunchService';
import { launchHuiduGame } from '../../../services/huiduGameService';
import { cleanupNotifications, onMessageListener ,getToken,} from '../../../services/firebase';
import { NotificationContext } from '../../../Context/NotificationContext';
import NotificationsSkyla from '../../../Icons/Notifications';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake } from '@fortawesome/free-solid-svg-icons';
// Animation keyframes
const clickAnimation = css`
  @keyframes clickEffect {
    0% {
      transform: scale(1);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.1);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const BottomNavWrapper = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #292d2e;
  border-top: 1px solid #3a3f40;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: none;
  z-index: 10000;
  @media (min-width: 769px) {
    display: none;
  }
  @media (max-width: 768px) {
    display: block;
  }
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
`;

const NavItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 8px;
  transition: all 0.2s ease;
  color: ${props => props.active === 'true' ? '#25ee89' : '#9CA3AF'};
  ${clickAnimation}
  
  &:hover {
    color: #25ee89;
  }
  
  ${props => props.active === 'true' && css`
    animation: clickEffect 0.3s ease-out;
  `}
`;

const NavIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  & svg {
    color: ${props => props.active ? '#25ee89' : '#9CA3AF'};
    stroke: ${props => props.active ? '#25ee89' : '#9CA3AF'};
    transition: all 0.2s ease;
  }
`;

const NavLabel = styled.span`
  font-size: 10px;
  font-weight: 500;
  transition: all 0.2s ease;
`;

const BottomNavigation = () => {
  const location = useLocation();
  const [loaded, setLoaded] = useState(false);
  const [navItems, setNavItems] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const { showNotification } = useContext(NotificationContext);
  const [notifications, setNotifications] = useState({ unread: [], read: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const { setGameUrl, setIsGameOpen, isGameOpen, isLuckySportGame, setIsLuckySportGame } = useGameLaunch();

  const handleSportsClick = async () => {
    try {
      const id = getUID();
      if (!id) {
        sendNotfication('Please login to play Sports', 'error');
        return;
      }

      setIsGameOpen(true);

      const credits = localStorage.getItem('credit') || '0';
      const coins = localStorage.getItem('coin') || 'PKR';

      // Launch LuckySport — same as Sports Exchange in sidebar
      const result = await launchHuiduGame(
        '92b24e4c25107367a80e0fe1a97c24e4', // LuckySport game UID
        id,
        credits,
        coins,
      );

      if (result && result.game_launch_url) {
        setGameUrl(result.game_launch_url);
        setIsLuckySportGame(true);  // Sports tab — keep nav visible
        setActiveTab('Sports');
      } else {
        setIsGameOpen(false);
        setIsLuckySportGame(false);
        sendNotfication('Failed to launch Sports', 'error');
      }
    } catch (error) {
      console.error('Failed to launch sports game:', error);
      setIsGameOpen(false);
      setIsLuckySportGame(false);
      sendNotfication(error.message || 'Failed to launch Sports', 'error');
    }
  };

  const loggedInNavItems = [
  { path: '/menu', icon: <MenuPlayIcon />, label: 'Menu' },
    { path: '/explore', icon: <SearchStarIcon />, label: 'Explore' },
    { path: '/casino', icon: <ClaudeIcon />, label: 'Casino' },
    { path: '/sports', icon: <GameIcon />, label: 'Sports', onClick: handleSportsClick },
    { path: '/notification', icon: <NotificationsSkyla/>, label: 'Notification' }
  ];

  const withoutLoginNavItems = [
    { path: '/menu', icon: <MenuPlayIcon />, label: 'Menu' },
    { path: '/casino', icon: <ClaudeIcon />, label: 'Casino' },
    { path: '/sports', icon: <GameIcon />, label: 'Sports', onClick: handleSportsClick },
  ];

  useLayoutEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token);
      setNavItems(!!token ? loggedInNavItems : withoutLoginNavItems);
      const currentItem = (!!token ? loggedInNavItems : withoutLoginNavItems)
        .find(item => item.path === location.pathname);
      setActiveTab(currentItem?.label || '');
    };

    checkAuthStatus();
    window.addEventListener('storage', checkAuthStatus);
    return () => window.removeEventListener('storage', checkAuthStatus);
  }, [location.pathname]);

  const support = () => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISTP_ID;
    
    window.$crisp.push(["config", "container:fullpage", true]);
    window.$crisp.push(["config", "position:reverse", true]);
    window.$crisp.push(["config", "hide:on:mobile", false]);
    window.$crisp.push(["config", "button:hide", true]);
    
    if (!loaded) {
      setLoaded(true);
      const script = document.createElement('script');
      script.src = "https://client.crisp.chat/l.js";
      script.id = "chtt";
      script.async = true;
      
      script.onload = function() {
        setTimeout(() => {
          window.$crisp.push(["do", "chat:open"]);
          const crispStyles = `
            .crisp-client .cc-1xry { display: none !important; }
            .crisp-client .cc-kv6t { visibility: visible !important; opacity: 1 !important; display: block !important; }
            .crisp-client .cc-k5k0 { visibility: visible !important; opacity: 1 !important; display: block !important; }
            @media screen and (max-width: 768px) {
              #crisp-chatbox { display: block !important; z-index: 1000000 !important; }
              .crisp-client .cc-kv6t { max-height: 100% !important; height: 100% !important; }
            }
          `;
          const styleSheet = document.createElement("style");
          styleSheet.id = "crisp-custom-styles";
          styleSheet.innerText = crispStyles;
          document.head.appendChild(styleSheet);
        }, 1000);
      };
      
      document.head.appendChild(script);
    } else {
      window.$crisp.push(["do", "chat:open"]);
    }
    
    addNewStyle("#crisp-chatbox { display: block !important; }");
    addNewStyle(".crisp-client .cc-1xry { display: none !important; }");
    
    wait(2000).then(() => {
      const close = document.querySelector(".cc-wdhl");
      if (close) {
        close.addEventListener("click", function () {
          addNewStyle("#crisp-chatbox { display: none !important; }");
          addNewStyle(".crisp-client { display: none !important; visibility: hidden !important; }");
          window.$crisp.push(["do", "chat:hide"]);
          window.$crisp.push(["do", "session:reset"]);
          const crispScript = document.getElementById("chtt");
          if (crispScript) crispScript.remove();
          const customStyles = document.getElementById("crisp-custom-styles");
          if (customStyles) customStyles.remove();
          setLoaded(false);
        });
      }
    });
  };

  const manageClick = (label, itemOnClick) => {
    setActiveTab(label);
    if (label === 'Chat') {
      support();
    
    } else if (itemOnClick) {
      itemOnClick();
    } else {
      // Close game iframe when navigating to other pages
      setIsGameOpen(false);
      setIsLuckySportGame(false);
    }
  };



  const fetchUnreadCount = async () => {
    try {
      const response = await fetch(`${API}/firebase/unread-count/${getUID()}`);
      const data = await response.json();
      if (data.success) {
        setUnreadCount(data.unreadCount);
      }
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    }
  };

  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/firebase/history/${getUID()}`);
      const data = await response.json();
      if (data.success) {
        setNotifications({
          unread: data.notifications.unread || [],
          read: data.notifications.read || []
        });
      }
      await fetchUnreadCount();
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      const response = await fetch(`${API}/firebase/mark-as-read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: getUID(),
          notificationIds: [notificationId]
        })
      });

      if (response.ok) {
        setNotifications(prev => {
          const updatedUnread = prev.unread.filter(n => n.id !== notificationId);
          const movedNotification = prev.unread.find(n => n.id === notificationId);
          return {
            unread: updatedUnread,
            read: movedNotification ? [...prev.read, { ...movedNotification, is_read: true }] : prev.read
          };
        });
        await fetchNotifications();
      }
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
    }
  };

  const markAllAsRead = async () => {
    try {
      const unreadIds = notifications.unread.map(notification => notification.id);
      const response = await fetch(`${API}/firebase/mark-as-read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: getUID(),
          notificationIds: unreadIds
        })
      });

      if (response.ok) {
        setNotifications(prev => ({
          unread: [],
          read: [...prev.read, ...prev.unread.map(n => ({ ...n, is_read: true }))]
        }));
        await fetchNotifications();
      }
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchUnreadCount();
  }, []);

  let notificationCounter = 0;
  const generateUniqueId = () => {
    notificationCounter += 1;
    return `${Date.now()}-${notificationCounter}`;
  };

  const setupNotifications = async () => {
    let unsubscribeFromMessages = null;

    try {
      if (!('Notification' in window)) {
        console.error('This browser does not support notifications');
        return () => {};
      }

      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
          console.log('Service Worker registered:', registration);
        } catch (error) {
          console.error('Service Worker registration failed:', error);
        }
      }

      const token = await getToken();
      console.log('fcm', token);
      await axios.post(`${API}/firebase/register`, {
        userId: getUID(),
        token,
        deviceType: navigator.userAgent,
        platform: 'web'
      });

      unsubscribeFromMessages = onMessageListener((payload) => {
        console.log('Received message payload:', payload);

        try {
          if (Notification.permission === 'granted') {
            const browserNotification = new Notification(payload.notification.title, {
              body: payload.notification.body,
              icon: '/logo192.png',
              tag: 'notification-' + generateUniqueId(),


            });

            browserNotification.onclick = (event) => {
              event.preventDefault();
              window.focus();
              browserNotification.close();
            };
          }

          showNotification({
            title: payload.notification.title || 'New Notification',
            body: payload.notification.body || '',
          });
        } catch (error) {
          console.error('Notification creation failed:', error);
        }
      });

    } catch (error) {
      console.error('Notification setup failed:', error);
      console.error('Error details:', error.message);
    }

    return () => {
      if (unsubscribeFromMessages) {
        unsubscribeFromMessages();
      }
    };
  };

  useEffect(() => {
    let unsubscribe;
    const setup = async () => {
      unsubscribe = await setupNotifications();
    };
    setup();

    return () => {
      if (unsubscribe) unsubscribe();
      cleanupNotifications();
    };
  }, []);
  console.log("unrrad count", unreadCount)

  // Hide nav when any iframe game is open EXCEPT LuckySport (Sports tab)
  if (isGameOpen && !isLuckySportGame) return null;

  return (
    <BottomNavWrapper>
     <NavContainer>
        {navItems.map((item) => {
          const isActive = activeTab === item.label;
          return (
            <NavItem
              key={item.path}
              to={item.path}
              onClick={(e) => {
                if (item.onClick || item.label === 'Sports' || item.label === 'Chat') {
                  e.preventDefault();
                }
                manageClick(item.label, item.onClick);
              }}
              active={isActive.toString()}
            >
              <NavIconWrapper active={isActive}>
                {item.label === 'Notification' && unreadCount > 0 ? (
                  <div style={{ position: 'relative' }}>
                    {item.icon}
                    <span 
                      style={{
                        position: 'absolute',
                        top: '-5px',
                        right: '-5px',
                        background: '#25ee89',
                        color: 'white',
                        borderRadius: '50%',
                        width: '15px',
                        height: '15px',
                        fontSize: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {unreadCount}
                    </span>
                  </div>
                ) : (
                  item.icon
                )}
              </NavIconWrapper>
              <NavLabel>{item.label}</NavLabel>
            </NavItem>
          );
        })}
      </NavContainer>
    </BottomNavWrapper>
  );
};

export default BottomNavigation;